import { HttpErrorIgnore } from '../../../../global';
import apiSvc, { BinaryFileType } from '../../../core/services/apiSvc';
import validSvc from '../../../core/validSvc';

export const GET_LIST = 'admin/mfrestrict/list';
const GET_EXCEL = 'admin/mfrestrict/excel';

export async function getExcel(fileName: string): Promise<HttpErrorIgnore | undefined> {
    // params
    if (!validSvc.isText(fileName)) {
        throw new Error('mfrRestrictionsRepo.getExcel, filename is required');
    }
    return apiSvc.postGetBinary(GET_EXCEL, {}, fileName, BinaryFileType.Excel);
}
